import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export const SMS_CONSENT_TEXT =
  "Ich möchte SMS-Benachrichtigungen zu meiner Buchungsanfrage, Terminbestätigung, Absage und eine Erinnerung 24 Stunden vor meinem Training erhalten.";

export const isValidDeMobile = (raw) => {
  if (!raw) return false;
  let s = raw.replace(/[\s\-/().]/g, "");
  if (s.startsWith("+49")) s = "0" + s.slice(3);
  else if (s.startsWith("0049")) s = "0" + s.slice(4);
  return /^01(5\d|6\d|7\d)\d{7,8}$/.test(s);
};

export const smsStepValid = (mobile, consent) => {
  const filled = !!(mobile && mobile.trim());
  if (filled && !isValidDeMobile(mobile)) return false;
  if (consent && !filled) return false;
  return true;
};

export const SmsOptIn = ({ mobile, consent, onMobileChange, onConsentChange }) => {
  const filled = !!(mobile && mobile.trim());
  const invalid = filled && !isValidDeMobile(mobile);

  return (
    <div className="space-y-3" data-testid="sms-optin">
      <div>
        <Label htmlFor="mobile" className="text-white">Mobilnummer (optional)</Label>
        <Input
          id="mobile"
          type="tel"
          value={mobile}
          onChange={(e) => onMobileChange(e.target.value)}
          placeholder="+49 170 1234567 oder 0170 1234567"
          className={`mt-1 bg-[#0A0A0A] ${invalid ? "border-red-500" : "border-white/20"}`}
          data-testid="input-mobile"
        />
        {invalid && (
          <p className="text-xs text-red-400 mt-1" data-testid="mobile-error">
            Bitte eine gültige deutsche Mobilfunknummer angeben (+49 oder 01...).
          </p>
        )}
      </div>

      <div className="flex items-start gap-3">
        <Checkbox
          id="sms-consent"
          checked={consent}
          onCheckedChange={(v) => onConsentChange(v === true)}
          className="mt-0.5 border-white/40 data-[state=checked]:bg-[#c1ff72] data-[state=checked]:text-[#0A0A0A]"
          data-testid="checkbox-sms-consent"
        />
        <Label htmlFor="sms-consent" className="text-sm text-white/90 leading-snug font-normal cursor-pointer">
          {SMS_CONSENT_TEXT} (freiwillig)
        </Label>
      </div>
      {consent && !filled && (
        <p className="text-xs text-red-400" data-testid="sms-consent-error">
          Bitte gib eine Mobilnummer an, um SMS zu erhalten.
        </p>
      )}

      <p className="text-xs text-[#71717A] leading-relaxed" data-testid="sms-privacy-note">
        Datenschutzhinweis: Deine Mobilnummer wird ausschließlich für Service-SMS zu dieser Buchung verwendet
        (keine Werbung) und zum Versand an unseren SMS-Dienstleister Twilio übermittelt. Rechtsgrundlage ist deine
        Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Du kannst sie jederzeit ohne Angabe von Gründen widerrufen –
        unter <Link to="/sms-abmeldung" className="underline hover:text-[#c1ff72]">SMS abbestellen</Link> oder per
        E-Mail. Die Buchung funktioniert auch ohne Mobilnummer. Mehr in der{" "}
        <Link to="/datenschutz" className="underline hover:text-[#c1ff72]">Datenschutzerklärung</Link>.
      </p>
    </div>
  );
};
